export class FiltersSettings {
  dataServiceApi: string;
}
